import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from '../../color-constants';

const Container = styled.div`
  box-sizing: content-box;
  min-height: 50px;

  display: flex;
  flex: 1 1 0px;

  background-color: rgba(255, 255, 255, 0.0001);
  ${props => props.selectable ? `
    :hover {
      background-color: #ECEBEB;
      cursor: pointer;
    }
  ` : ``}
  transition: background-color .2s;
  border: 1px solid #ECEBEB;
  margin-top: -1px;

  :first-child {
    margin-top: 0px;
  }
`;

const InformationWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

const Title = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #626469;
  word-break: break-word;
`;

const FormatWithIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const ExtensionLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${PRIMARY_COLOR};
`;

const IconWrapper = styled.div`
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-left: 10px;
  text-decoration: none !important;
`;

const DownloadIcon = styled(IconWrapper)`
  color: ${PRIMARY_COLOR};
  border-radius: 2px;
`;

const LoadingSpinner = styled.div`
  box-sizing: content-box;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #636363;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 2s linear infinite;
  margin: 0px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

class ExportLink extends React.Component {

  static propTypes = {
    name: PropTypes.string,
    renderTitleComponent: PropTypes.func,
    loading: PropTypes.bool,
    onDownload: PropTypes.func.isRequired,
    extensionLabel: PropTypes.string,
    hideIcon: PropTypes.bool,
    icon: PropTypes.string
  }

  render = () => {
    const isSelectable = !this.props.loading;
    const hideIcon = this.props.hideIcon;
    const showIcon = isSelectable && !hideIcon;


    return (
      <Container selectable={isSelectable} onClick={() => {
        this.props.onDownload();
      }}>
        <InformationWrapper>
          {this.props.renderTitleComponent ? this.props.renderTitleComponent() : <Title>{this.props.name}</Title>}
          <FormatWithIconWrapper>
            {this.props.loading ? <LoadingSpinner></LoadingSpinner> : <ExtensionLabel>{this.props.extensionLabel}</ExtensionLabel>}
            {showIcon && <DownloadIcon>
              <qds-icon name={this.props.icon || 'arrow-down-tray'}></qds-icon>
            </DownloadIcon>}
          </FormatWithIconWrapper>
        </InformationWrapper>
      </Container>
    );
  }
}

export default ExportLink;
